import _axios from 'axios'
import { Analytics } from '../analytics'

const analyticsTrack = (url, errorCode, errorMessage) => {
  const analyticsData = {
    '401': {
      pageName: 'Error: Unauthorized (401)',
      eventType: 'Login',
      eventAction: 'Unauthorized',
      errorMessage: 'Unauthorized',
    },
    '403': {
      pageName: 'Error: Access denied (403)',
      eventType: 'Access',
      eventAction: 'Denied',
      errorMessage: 'Access denied',
    },
    '404': {
      pageName: 'Error: Page not found (404)',
      errorMessage: 'Page not found',
    },
    '500': {
      pageName: 'Error: Internal server error (500)',
    },
  }
  Analytics.pageName = analyticsData[`${errorCode}`].pageName
  Analytics.setTrackingData({
    [Analytics.keys.pageName()]: Analytics.pageName,
    [Analytics.keys.viewChange()]: 'Contact',
    [Analytics.keys.eventType(0)]:
      analyticsData[`${errorCode}`].eventType || 'Error',
    [Analytics.keys.eventAction(0)]:
      analyticsData[`${errorCode}`].eventAction || 'Technical error',
    [Analytics.keys.errorCode()]: errorCode,
    [Analytics.keys.errorMessage()]:
      analyticsData[`${errorCode}`].errorMessage || errorMessage,
    [Analytics.keys.errorCausingURL()]: url,
  })

  Analytics.trackPage()
}

const axios = _axios.create({
  baseURL: process.env.REACT_APP_API_GATEWAY,
})

axios.interceptors.response.use(
  response => response,
  error => {
    if (error.status) {
      analyticsTrack(error.config.url, error.status, error.message)
    }
    return Promise.reject(error)
  }
)

export default axios
